import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './chamadoForm';
import DateFormat from '../common/dateFormat/DateFormat';

import { setModoTela, initForm, salvar, excluir, finalizar, cancelar, getLista } from './chamadoActions';

class Chamado extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({});
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th colspan={1}>Status</Th>
								<Th colspan={1}>Assunto</Th>
								<Th colspan={1}>Descrição</Th>
								<Th colspan={1}>Solicitação</Th>
								<Th colspan={1}>Usuário</Th>
								<Th colspan={1}>Final/Cancel</Th>
								<Th colspan={1}>Usuário</Th>
								<Th colspan={1}></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`${item.datahora_finalizacao ? 'Finalizado' : (item.datahora_cancelamento ? 'Cancelado' : 'Aberto')}
										${item.assunto} ${item.descricao} ${item.nome_usuario_inclusao} ${item.nome_usuario_finalizacao || item.nome_usuario_cancelamento}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.datahora_finalizacao ? 'Finalizado' : (item.datahora_cancelamento ? 'Cancelado' : 'Aberto')}</Td>
									<Td>{item.assunto}</Td>
									<Td>{item.descricao}</Td>
									<Td>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}</Td>
									<Td>{item.nome_usuario_inclusao}</Td>
									<Td>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao || item.datahora_cancelamento)}</Td>
									<Td>{item.nome_usuario_finalizacao || item.nome_usuario_cancelamento}</Td>
									<Td alignRight minWidth={100}>

										<ButtonTable
											type={'success'}
											icon={'fas fa-check'}
											visible={this.state.linhaSelecionada == item.id && this.props.sessao.id == 1 && !item.datahora_finalizacao && !item.datahora_cancelamento}
											event={() => {
												this.props.finalizar(item);
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-ban'}
											visible={this.state.linhaSelecionada == item.id && this.props.sessao.id == 1 && !item.datahora_finalizacao && !item.datahora_cancelamento}
											event={() => {
												this.props.cancelar(item);
											}} />

										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id && !item.datahora_finalizacao && !item.datahora_cancelamento && item.id_usuario_inclusao == this.props.sessao.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id && !item.datahora_finalizacao && !item.datahora_cancelamento && item.id_usuario_inclusao == this.props.sessao.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.chamado.modoTela,
	lista: state.chamado.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, finalizar, cancelar, getLista }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Chamado);
